import React, { useState, useEffect } from "react";
// Chakra imports
import {
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import { FaPencilAlt, FaCircleNotch } from "react-icons/fa";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import useGetUsagesAll from "../../hooks/useGetUsagesAll";
// import CreateUsage from "../../modals/CreateUsage";
import EditUsage from "../../modals/EditUsage";
import Pagination from "./Pagination";



function UsagesTable({
  reloadTotal,
}) { 
    const [ page, setPage ] = useState(1); 
    const pageLimit = 12;
    let { 
      usages, 
      totalUsages,
      setGettingUsages, 
      gettingUsages, 
      gettingUsagesReqSuccess 
    } = useGetUsagesAll({ page, limit: pageLimit, isToolsClerk: true });
    const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
    const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
    const [ toEditUser, setToEditUser ] = useState(null);
  
  
    useEffect(() => {
      setGettingUsages(true);
    }, [page]);
  
    useEffect(() => {
      // console.log(usages);
    }, [usages]);
  
    const reloadPage = () => {
      setGettingUsages(true);
      if(reloadTotal) {
        reloadTotal();
      }
    }
  
    const selectEditItem = (id) => {
      // console.log(id);
      const user = usages.find((c) => c.id === id);
      // console.log(user.email);
      setToEditUser(user);
      onOpenEdit(true);
    }
  
    const textColor = useColorModeValue("gray.700", "white");

    return (
        <Card overflowX={{ sm: "scroll", xl: "hidden" }}>

          <CardHeader p="6px 0px 22px 0px">
              <Flex w="100%"
              flexDirection={{
                  sm: "row",
                  md: "row",
              }}
              alignItems={{ xl: "center" }}>
              <Box>
                  <Text fontSize="lg" color={textColor} fontWeight="bold" pb=".5rem">
                  Expenditures
                    <IconButton 
                      ml="8px"
                      onClick={reloadPage}
                      title="Reload Data"
                      icon={<Icon as={FaCircleNotch} me="4px" />} 
                    />
                  </Text>
              </Box>
              <Spacer />
              {/* <Box>
                  <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                  Create New
                  </Button>
              </Box> */}
              </Flex>
          </CardHeader>
          <CardBody>
              <Flex direction="column" w="100%">
              <Table variant="simple" color={textColor}>
                  <Thead>
                  <Tr my=".8rem" pl="0px" color="gray.400">
                      <Th pl="0px" color="gray.400">Amount</Th>
                      <Th pl="0px" color="gray.400">Description</Th>
                      <Th pl="0px" color="gray.400">Created Date</Th>
                      <Th pl="0px" color="gray.400">Actions</Th>
                  </Tr>
                  </Thead>
                  <Tbody>
                  {gettingUsages ? 
                      <Tr my=".8rem" >
                      <Td minWidth={{ sm: "250px" }} pl="0px" colSpan={4}>
                          <Progress isIndeterminate />
                      </Td>
                      </Tr>
                      : usages.map((user) => {
                      return (
                          <Tr my=".8rem" pl="0px">
                            <Td pl="0px">
                              ₱{Number(user.amount).toLocaleString()}
                            </Td>
                            <Td pl="0px">
                                {user.purpose}
                            </Td>
                            <Td  pl="0px">
                                {new Date(user.createdAt).toLocaleString()}
                            </Td>
                            <Td  pl="0px">
                                <Button p="0px" bg="transparent" onClick={() => selectEditItem(user.id)}>
                                <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                    <Icon as={FaPencilAlt} me="4px" />
                                    <Text fontSize="xs" fontWeight="semibold">
                                    EDIT
                                    </Text>
                                </Flex>
                                </Button>
                            </Td>
                          </Tr>
                      );
                      })
                  }
                  </Tbody>
              </Table>
              <Pagination 
                  totalItems={totalUsages}
                  pageRows={pageLimit}
                  currentPage={page}
                  onPageChanged={setPage}
              />
              </Flex>


              
          </CardBody>


          {/* <CreateUsage 
            isOpen={isOpenCreate}
            onClose={onCloseCreate}
            successCallback={reloadPage} 
            isToolsClerk={true}
          />
          */}
                 
          <EditUsage 
            isOpen={isOpenEdit}
            onClose={() => {
              setToEditUser(null);
              onCloseEdit();
            }}
            successCallback={reloadPage}
            userData={toEditUser}
            isToolsClerk={true}
          /> 
      </Card>
      );
}


export default UsagesTable;
